/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251227
    
*/
'use strict';

import {
    bindSelect,
    getUrlParam
} from './ctssHtml.js';
import {
    getPromise,
    savePromise
} from './ctssJQuery.js';
import { getUSStates } from './ctssUSStates.js';
import {
    confirmedPW,
    isDataModified,
    setModified,
    validEmail,
    validPW
} from './ctssVal.js';
import {
    changeBillingIntervalDDL
} from './snBilling.js';
import {
    getEmailExistsAsync
} from './snMemberAuthentication.js'; 
import { appDebugMode } from './snSite.js';

/* private functions */
const enableSubscribe = () => {
    const canSubscribe = ($('#editName').val().length > 0 &&
        $('#editAdr1').val().length > 0 &&
        $('#editCity').val().length > 0 &&
        $('#ddlStates').val().length > 0 &&
        isValidEmail &&
        ($('#pwFlds').hasClass('hidden') || (isValidPW && isPWConfirmed)) &&
        $('#cbTOS_Privacy_AgreedTo').is(':checked'));
    if (canSubscribe) {
        $('#btnSubscribe').removeAttr('disabled');
    } else {
        $('#btnSubscribe').attr('disabled', 'disabled');
    }
};

const getCoupon = async (promoCode) => {
    try {
        coupon = await getPromise({
            url: `Billing/Coupon?promoCode=${promoCode}`,
            divErrMsg: 'divCouponErrMsg',
            fnErr: (data) => {
                $('#divCouponErrMsg').text(getMySNApiError(data))
                    .removeClass('hidden successBoldText')
                    .addClass('errBoldText');
                hasCoupon = false;
                updateOrderSummary();
            }
        });
        if (coupon) {
            hasCoupon = true;
            $('#divCouponErrMsg').text('Promo code has been applied')
                .removeClass('hidden errBoldText')
                .addClass('successBoldText');
            updateOrderSummary();
        }

    }
    catch (error) { }
}

const updateOrderSummary = () => {
    const plan = plans.find(x => x.id === parseInt($('#ddlPlans').val(), 10));
    $('#lblPlan').text(plan.description);
    $('#lblPlanAmt').text('$' + plan.price.toFixed(2));
    $('#lblTotal').text(`${plan.billingInterval === 1 ? 'Annual' : 'Monthly'} Total`)
    if (hasCoupon) {
        let desc = '';
        let amt = '';
        if (coupon.pcntOff === 0) {
            desc += 'Discount ($' + coupon.discount + ' off)*';
            amt = coupon.discount.toFixed(2);
        } else {
            desc += 'Discount (' + coupon.pcntOff + '% off)*';
            amt = (coupon.pcntOff / 100. * plan.price).toFixed(2);
        }
        const durationDesc = plan.billingInterval === 1
            ? 'year'
            : coupon.monthsDuration === 1
                ? 'month'
                : 'months';
        $('#lblDiscount').text(desc).removeClass('hidden');
        $('#lblDiscountAmt').text('-$' + amt).removeClass('hidden');
        $('#lblTotalAmt').text('$' + (plan.price - amt).toFixed(2));
        $('#billDesc').text('You will be billed this discounted amount for ' + coupon.monthsDuration + ` ${durationDesc} after your 30 day trial...`);
    } else {
        $('#lblDiscount').addClass('hidden');
        $('#lblDiscountAmt').addClass('hidden');
        $('#lblTotalAmt').text('$' + plan.price.toFixed(2));
        $('#billDesc').text(`You will be billed the ${plan.billingInterval === 1 ? 'annual' : 'monthly'} total after your 30 day trial...`);
    }
}

/* public variables and functions */

let coupon;
let hasCoupon = false;
let isPWConfirmed = false;
let isValidEmail = false;
let isValidPW = false;
let plans = [];

const initAsync = async () => {
    window.onbeforeunload = () => {
        if (isDataModified() === true) {
            return "You have not subscribed to My Sermon Notes...";
        }
    };

    try {
        plans = await snBilling.getPlansDDLAsync();

        const currentPlan = plans[plans.findIndex(x => x.id === parseInt(ctssHtml.getUrlParam({ key: 'plan', dflt: '20' }), 10))];
        setPlanOptionsDDL({ billingInterval: currentPlan.billingInterval });
        $('#ddlPlans').val(currentPlan.id);
        $('#ddlBillingInterval').val(currentPlan.billingInterval);
        updateOrderSummary();

        const promoCode = getUrlParam({ key: 'promocode', dflt: '' });
        if (promoCode?.length > 0) {
            $('#editPromoCode').val(promoCode);
            await getCoupon(promoCode);
        }

    }
    catch (error) { }

    $('input[type=text]:not(#editAdminEmail):not(#editPromoCode)').on('keyup', () => {
        setModified(true);
        enableSubscribe();
    });
    $('#cbTOS_Privacy_AgreedTo').on('change', () => {
        setModified(true);
        enableSubscribe();
    });

    bindSelect({ id: 'ddlStates', items: getUSStates() });

    $('#ddlPlans').on('change', () => updateOrderSummary());

    $('#ddlBillingInterval').on('change', () => {
        changeBillingIntervalDDL();
        updateOrderSummary();
    });

    $('#editAdminEmail').on('keyup', async () => {
        isValidEmail = validEmail({
            emailCtrl: 'editAdminEmail',
            emailErrMsgId: 'adminEmailErrMsg'
        });
        if (isValidEmail) {
            try {
                const emailExists = getEmailExistsAsync({ email: $('#editAdminEmail').val() });
                if (emailExists) {
                    $('#pwFlds').addClass('hidden');
                }
                else {
                    isValidPW = false;
                    isPWConfirmed = false;
                    $('#editAdminPW').val('');
                    $('#editConfirmPW').val('');
                    $('#pwFlds').removeClass('hidden');
                }
                enableSubscribe();
            }
            catch (error) { }
        } else {
            isValidPW = false;
            isPWConfirmed = false;
            enableSubscribe();
        }
    });

    $('#editAdminPW').on('keyup', () =>
        isValidPW = validPW({
            pwCtrl: 'editAdminPW',
            minQty: 8,
            minLenMsgId: 'pwLen',
            uppercaseMsgId: 'pwUpper',
            lowercaseMsgId: 'pwLower',
            numberMsgId: 'pwNumber',
            specialCharMsgId: 'pwSpecial'
        })
    );

    $('#editConfirmPW').on('keyup', () => {
        isPWConfirmed = confirmedPW({
            pwCtrl: 'editAdminPW',
            confirmPWErrMsgId: 'confirmPWErrMsgId'
        });
        enableSubscribe();
    });

    $('#editPromoCode').on('keyup', () => {
        $('#editPromoCode').val().length > 4
            ? $('#btnGetCoupon').removeAttr('disabled')
            : $('#btnGetCoupon').attr('disabled', 'disabled');
    });

    $('#continueDlg').on('hide.bs.modal', () => {
        window.location.href = 'https://mysermonnotes.com';
    });

    $('#btnGetCoupon').on('click', async () => {
        try {
            await getCoupon($('#editPromoCode').val());
        }
        catch (error) { }
    });

    $('#btnSubscribe').on('click', async () => {
        $('#btnSubscribe').attr('disabled', 'disabled');
        const bsp = { BillingPlanID: $('#ddlPlans').val() };
        if (hasCoupon) {
            bsp.BillingCouponID = coupon.id;
        };
        await savePromise({
            url: 'Applicants/Apply',
            data: {
                Name: $('#editName').val(),
                Adr1: $('#editAdr1').val(),
                Adr2: $('#editAdr2').val(),
                City: $('#editCity').val(),
                St: $('#ddlStates').val(),
                ZIP: $('#editZip').val(),
                AdminFirstName: $('#editAdminFirstName').val(),
                AdminLastName: $('#editAdminLastName').val(),
                AdminEmail: $('#editAdminEmail').val(),
                AdminPW: $('#pwFlds').hasClass('hidden') ? null : $('#editAdminPW').val(),
                BillingSubscriptionParams: bsp
            }
        })
        .then(() => {
            setModified(false);
            $('#continueDlg').modal('show');
        });
    });
};

window.snApply = {
    initAsync
};
